var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "py-4" },
    [
      _c("modal-filter", {
        attrs: {
          onfilter: _vm.onfilter,
          filter: _vm.filter,
          exclude: ["state_id", "payment_state_id"],
        },
        on: {
          onclose: function ($event) {
            _vm.onfilter = false
          },
          onfilter: function ($event) {
            return _vm.ONFILTER()
          },
        },
      }),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("main", [
        _c("div", { staticClass: "container-fluid" }, [
          _c(
            "div",
            { staticClass: "vstack gap-4" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex flex-column flex-md-row gap-3 justify-content-between",
                },
                [
                  _c(
                    "form",
                    {
                      staticClass: "d-flex gap-3 row",
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.FILTER()
                        },
                      },
                    },
                    [
                      _c("div", [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-h px-3 btn-neutral",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                _vm.onfilter = true
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "bi bi-funnel me-2" }),
                            _vm._v(" "),
                            _c("span", [_vm._v("Filtro")]),
                            _vm._v(" "),
                            _c("span", { staticClass: "vr opacity-20 mx-3" }),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "text-xs text-primary" },
                              [_vm._v(_vm._s(_vm.count_filter))]
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-h px-3 btn-neutral",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.SORT()
                              },
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "me-2",
                              class:
                                _vm.filter.sortDesc == "ASC"
                                  ? "bi bi-sort-alpha-up"
                                  : "bi bi-sort-alpha-down-alt",
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(_vm.filter.sortDesc))]),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-4 px-0" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "input-group input-group-sm input-group-inline",
                          },
                          [
                            _vm._m(1),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.filter.search,
                                  expression: "filter.search",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { type: "text", placeholder: "Buscar..." },
                              domProps: { value: _vm.filter.search },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.filter,
                                    "search",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-h px-3 btn-primary",
                            attrs: { type: "submit" },
                          },
                          [
                            _vm.loading == "filter"
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "spinner-border spinner-border-sm",
                                    attrs: { role: "status" },
                                  },
                                  [
                                    _c("span", { staticClass: "sr-only" }, [
                                      _vm._v("Loading..."),
                                    ]),
                                  ]
                                )
                              : _c("span", [_vm._v("Buscar")]),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-h px-3 btn-danger",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.CLEAR()
                              },
                            },
                          },
                          [
                            _vm.loading == "clear"
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "spinner-border spinner-border-sm",
                                    attrs: { role: "status" },
                                  },
                                  [
                                    _c("span", { staticClass: "sr-only" }, [
                                      _vm._v("Loading..."),
                                    ]),
                                  ]
                                )
                              : _c("span", [_vm._v("Limpiar")]),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c("list-task", {
                attrs: {
                  calculate: _vm.calculate,
                  confirm: _vm.confirm,
                  items: _vm.items,
                  loading: _vm.loading,
                },
                on: {
                  options: _vm.GET_OPTIONS,
                  on_calculate: _vm.CALCULATE,
                  on_confirm: _vm.CONFIRM,
                  add_line: _vm.ADD_LINE,
                  remove_line: _vm.REMOVE_LINE,
                },
              }),
            ],
            1
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", [
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "pb-4" }, [
          _c("div", { staticClass: "row align-items-end" }, [
            _c("div", { staticClass: "col-sm col-12" }, [
              _c("h1", { staticClass: "h2 ls-tight" }, [_vm._v("Facturación")]),
            ]),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text pe-2 text-sm" }, [
        _c("i", { staticClass: "bi bi-search" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }